// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const fasObjectsAlignLeft: CreateIconOptions = {
  "displayName": "FASObjectsAlignLeft",
  "viewBox": "0, 0, 512, 512",
  "d": "M0 24L0 488c0 13.3 10.7 24 24 24s24-10.7 24-24L48 24C48 10.7 37.3 0 24 0S0 10.7 0 24zM176 64c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48L176 64zm0 224c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-160 0z"
};
